module.exports = __webpack_public_path__ + "img/pre_20211001_bookingflow.bfc55196.png";